import React from 'react'
import useFilterMeta from './use-filter-meta'
import useConstrainable from './use-constrainable'
import useOnMetaUpdate from './use-on-meta-update'
import isEqual from 'lodash/isEqual'

export default function useFilterValue (name, defaultValue = null, key = 'value', hasFocus = false, forceSetFromResponse = false) {
  const constrainable = useConstrainable()

  const valueFromMeta = useFilterMeta(name, key, defaultValue)

  const [value, setValue] = React.useState(valueFromMeta)

  React.useEffect(() => {
    if (hasFocus === true) {
      return
    }
    if (isEqual(value, valueFromMeta) === false) {
      setValue(valueFromMeta)
    }
  }, [valueFromMeta])

  useOnMetaUpdate(() => {
    const valueFromResponse = constrainable.getFilterMeta(name, key, value)
    if (valueFromResponse !== null && typeof valueFromResponse !== 'undefined' && hasFocus === false) {
      if (forceSetFromResponse === true || isEqual(valueFromResponse, valueFromMeta) === false) {
        setValue(valueFromResponse)
      }
    }
  }, [value, name, key, hasFocus])

  return [value, setValue]
}
